// export const BASE_URL = "/api";

// export const BASE_URL = "https://myportfolio-server-5fqf.onrender.com";
export const BASE_URL = window.location.hostname === "localhost" ? "http://localhost:7777" : "https://myportfolio-server-5fqf.onrender.com";